<template>
    <form-accordion
        name="roads"
        section="Roads"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <roads-exist
            v-model="roads_roadways_exist"
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <roads-need-construction
            v-if="! roads_roadways_exist"
            v-model="roads_need_construction"
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <roads-who-responsible
            v-if="! roads_roadways_exist && roads_need_construction"
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <roads-notes
            :commercial="property.commercial"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import RoadsExist from './roads-exist.vue';
import RoadsNeedConstruction from './roads-need-construction.vue';
import RoadsWhoResponsible from './roads-who-responsible.vue';
import RoadsNotes from './roads-notes.vue';

export default {
    components: {
        RoadsExist,
        RoadsNeedConstruction,
        RoadsWhoResponsible,
        RoadsNotes,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            roads_roadways_exist: this.getRoadwaysExist(),
            roads_need_construction: this.property.commercial.roads_need_construction,
        }
    },

    methods: {
        getRoadwaysExist() {
            return this.property.commercial.roads_roadways_exist === null
                ? true
                : this.property.commercial.roads_roadways_exist
        },
    },

}
</script>
